// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__11u_f","label":"Labeled_label__SY1RK","divider":"Labeled_divider__zGoM3"};